import VisitorCard from '$blocks/AppHome/components/VisitorCard'
import VisitorList from '$blocks/AppHome/components/VisitorList'
import Loading from '$components/Loading'
import { useRouteSummary } from '$contexts/RouteContext/hooks'
import { FilterTypeVisitors, getTenantDeviceLogs } from '$services/api'
import { useRequest } from 'ahooks'
import {
  AlertTriangle,
  CodeXml,
  LaptopMinimal,
  LucideIcon,
  MonitorSmartphone,
  Smartphone,
  Tablet
} from 'lucide-react'
import { useEffect, useState } from 'react'

const tabs: { label: string; value: FilterTypeVisitors }[] = [
  { label: 'Device', value: 'device' },
  { label: 'Browser', value: 'browser' },
  { label: 'OS', value: 'os' }
]

type TDevices =
  | 'desktop'
  | 'mobile'
  | 'tablet'
  | 'api-client-tools'
  | 'robot'
  | 'unknown'

const Icons: Record<TDevices, LucideIcon> = {
  desktop: LaptopMinimal,
  mobile: Smartphone,
  tablet: Tablet,
  'api-client-tools': CodeXml,
  robot: AlertTriangle,
  unknown: MonitorSmartphone
}

const DeviceLogs = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].value)

  const { route } = useRouteSummary()
  const { tenantId } = route.params

  const { run, data, loading } = useRequest(getTenantDeviceLogs, {
    manual: true
  })

  useEffect(() => {
    if (!tenantId) return
    run({ group_by: activeTab as FilterTypeVisitors })
  }, [tenantId, activeTab, run])

  const { data: deviceLogs = [] } = { ...data }

  const formattedList = deviceLogs.map(v => ({
    ...v,
    Icon: activeTab === 'device' ? Icons[v.name as TDevices] : undefined
  }))

  return (
    <VisitorCard
      header="Device Logs"
      tabs={tabs}
      currentTab={activeTab}
      onChangeTab={tab => setActiveTab(tab as FilterTypeVisitors)}
    >
      {loading && <Loading />}

      <VisitorList
        title={tabs.find(d => d.value === activeTab)?.label ?? ''}
        data={formattedList}
      />
    </VisitorCard>
  )
}

export default DeviceLogs
